<template>
  <div class="avatar-container">
    <img :src="url" :style="{ width: size + 'px', height: size + 'px' }" />
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      require: true,
    },
    size: {
      type: Number,
      default: 150,
    },
  },
};
</script>

<style scoped lang="less">
.avatar-container {
  img {
    border-radius: 50%;
    object-fit: cover;
    display: block;
  }
}
</style>
